import MixpanelService from '@/services/mixpanelService';

// Initialize Mixpanel
MixpanelService.init(process.env.VUE_APP_MIXPANEL_TOKEN);

export default MixpanelService;
